import React from 'react'

// Lodash
import _isNil from 'lodash/isNil'
import _map from 'lodash/map'

// Components
import { ScheduleIcon } from '../styled'

// Constants
import { EMPTY_OBJECT } from '../../../constants/base.constants'
import { MINIMUM_NOTES_COUNT } from '../../../constants/gettingStarted/general'
import { PATIENTS_LIST_TASK } from '../../../constants/gettingStarted/tasks'

export const isGettingStartedCardDisabled = (
  enabledFlagFromStore,
  fetchingNotesCount,
  notesCount
) =>
  (!_isNil(enabledFlagFromStore) && !enabledFlagFromStore) ||
  fetchingNotesCount ||
  (!fetchingNotesCount && notesCount >= MINIMUM_NOTES_COUNT)

const addCustomRendererToPatientsTask = (task = EMPTY_OBJECT) => {
  const { id } = task
  if (id !== PATIENTS_LIST_TASK.id) {
    return task
  }
  return {
    ...task,
    renderTitle: () => {
      return (
        <>
          <span>Tap Patients </span><ScheduleIcon />
          <span> to see your schedule or patient list</span>
        </>
      )
    }
  }
}

export const addCustomRenderersToOobeTasks = (oobeTasks = EMPTY_OBJECT) => {
  const { tasks } = oobeTasks
  return {
    ...oobeTasks,
    tasks: _map(tasks, addCustomRendererToPatientsTask)
  }
}
